import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { I18nProvider, SUPPORTED, DEFAULT_LANG } from "@/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsConditions from "@/pages/TermsConditions";
import ThankYou from "@/pages/ThankYou";
import NotFoundRedirect from "@/components/NotFoundRedirect";

// Scroll to top on route change EXCEPT when only the language segment changes
function ScrollToTop() {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  // pathAfterLang identifies the "page" regardless of language
  const pathAfterLang = SUPPORTED.includes(parts[0]) ? parts.slice(1).join("/") : parts.join("/");
  const prevRef = React.useRef(pathAfterLang);
  useEffect(() => {
    if (prevRef.current !== pathAfterLang) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      prevRef.current = pathAfterLang;
    }
  }, [pathAfterLang]);
  return null;
}

function LangGuard({ children }) {
  const { lang } = useParams();
  if (!SUPPORTED.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  }
  return children;
}

function LocalizedRoutes() {
  return (
    <I18nProvider>
      <LangGuard>
        <Layout>
          <Routes>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms-conditions" element={<TermsConditions />} />
            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>
        </Layout>
      </LangGuard>
    </I18nProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang/*" element={<LocalizedRoutes />} />
        <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
